'use es6';

import ErrorPage from 'ContentEditorUI/components/app/ErrorPage';
import { APP_ERRORS } from 'ContentEditorUI/lib/app/constants';
import { jsx as _jsx } from "react/jsx-runtime";
export default (({
  canContactSupport
}) => /*#__PURE__*/_jsx(ErrorPage, {
  appErrorCategory: APP_ERRORS.NOT_ALLOWED,
  canContactSupport: canContactSupport
}));